import { render, staticRenderFns } from "./FilterFields.vue?vue&type=template&id=36be4df5&scoped=true"
import script from "./FilterFields.vue?vue&type=script&lang=js"
export * from "./FilterFields.vue?vue&type=script&lang=js"
import style0 from "./FilterFields.vue?vue&type=style&index=0&id=36be4df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be4df5",
  null
  
)

export default component.exports